import React from 'react';
import { Form, Input } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import RichTextInput from 'components/RichTextInput';

import EditDependencies from './EditDependencies';
import messages from './messages';

const EditText = ({
  intl: { formatMessage: $t },
  text, dependencies, dependencyOperator, surveyQuestions = [],
  form, onSubmit,
}) => {
  const initialValues = {
    title: text.title,
    body: text.body,
    dependencies,
    dependencyOperator,
  };

  return (
    <Form layout="vertical" form={form} onFinish={onSubmit} initialValues={initialValues}>
      <Form.Item
        name="title"
        label={<FormattedMessage {...messages.textTitle} />}
        rules={[{ required: true, message: $t(messages.textTitleRequired) }]}
      >
        <Input placeholder={$t(messages.textTitlePlaceholder)} />
      </Form.Item>
      <Form.Item
        name="body"
        label={<FormattedMessage {...messages.textBody} />}
        rules={[{ required: true, message: $t(messages.textBodyRequired) }]}
      >
        <RichTextInput placeholder={$t(messages.textBodyPlaceholder)} />
      </Form.Item>

      <EditDependencies questions={surveyQuestions} />
    </Form>
  );
};

export default injectIntl(EditText);
